import { render } from "./KnowledgeBaseSidecar.vue?vue&type=template&id=4a116b93&scoped=true"
import script from "./KnowledgeBaseSidecar.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseSidecar.vue?vue&type=script&lang=js"

import "./KnowledgeBaseSidecar.vue?vue&type=style&index=0&id=4a116b93&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a116b93"]])

export default __exports__